<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<!--
  role="alert" so assistive technology announces the failure. This sheet is only ever opened by
  ErrorService, so it is always an error and never an informational message.
-->
<div role="alert">
  <div class="cssLayoutRowStartCenter bottom-button" style="overflow: hidden;">
    <div class="icon">
      <img width="50" src="assets/img/SP_Icon_Alert.png" />
    </div>
    <div>
      <div>
        <h2>{{ displayTitle }}</h2>
      </div>
      <div class="messagebody">
        {{ displayMessage }}
      </div>
    </div>
    <div>
      <button (click)="close()" mat-icon-button aria-label="Close" class="no-outline">
        <mat-icon title="Close" class="icon-color icon-24px" fontIcon="mdi-close-circle-outline"></mat-icon>
      </button>
    </div>
  </div>
</div>
